import { useRef } from 'react';

import { useIsClamped } from '@crm/shared/lib';

import { getDealInfoText } from '../../lib';
import { TDeal } from '../../model/deal';

interface IDealCardTitleProps {
    objectType: TDeal['objectType'];
    area: TDeal['area'];
    name: TDeal['name'];
    unit: TDeal['unit'];
}

export const DealCardTitle = ({ objectType, area, name, unit }: IDealCardTitleProps) => {
    const titleRef = useRef<HTMLParagraphElement>(null);
    const isClamped = useIsClamped(titleRef);
    const dealInfo = getDealInfoText({ objectType, area, joinSeparator: ' ', unit });

    const dealCardText = [name, dealInfo].filter(Boolean).join(' | ');
    const areaText = getDealInfoText({ objectType: null, area, joinSeparator: ' ', unit });
    const dealCardTextWithoutArea = areaText
        ? dealCardText.slice(0, -areaText.length)
        : dealCardText;

    if (dealCardText.length === 0) {
        return null;
    }

    return (
        <h4
            className="line-clamp-2 max-w-45.25 min-w-0 font-medium text-smtr-main-black-100"
            ref={titleRef}
            title={isClamped ? dealCardText : undefined}
        >
            {dealCardTextWithoutArea}
            {areaText && <span className="inline-block whitespace-nowrap">{areaText}</span>}
        </h4>
    );
};
